export const selectFilters = (state) => state.capture.dashboard.filters;
export const selectRange = (state) => state.capture.dashboard.filters.range;
